module.exports = __webpack_public_path__ + "img/menu-expand.59e744e6.svg";